import React from 'react'

const DetailboxGrafis = ({ ...props }) => {
    return (
        <div className="ttm-pf-single-detail-box mb-35">
            <div className="ttm-pf-single-title">
                <h5>{props.Title}</h5>
            </div>
            <p>{props.Description}.</p>
            <ul className="ttm-pf-detailbox-list">
                <li><i className="fa fa-calendar" /><span> Dibuat Tanggal :</span>{props.CreatedDate}</li>
                <li><i className="ti ti-world" /><span> URL : </span><code>{props.Slug}</code></li>
            </ul>
        </div>
    )
}

export default DetailboxGrafis
